export default "__VITE_ASSET__CYFZwjMT__"